'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('inomialEventLogService', [
      '$http',
      '$q',
      'proxyprefix',
      'smileCodesService',
      function(
        $http,
        $q,
        proxyprefix,
        smileCodesService,
      ) {
        function getSmileCode(smileCodeName) {
          return smileCodesService.getCode(smileCodeName);
        }

        function raiseTicket(ticketNumber, options) {
          var deferred = $q.defer();

          $http.post(proxyprefix + '/raiseTicket', {
            templateTicketNumber: ticketNumber,
            NewTicketRequest: {
              Body: options.description,
              Properties: {
                'String': 'Fetch Retail toolbox action'
              }
            }
          })
            .then(function(data) {
              deferred.resolve(data.data);
            }, function(error) {
              deferred.reject(error);
            });
          return deferred.promise;
        }

        function logEvent(options) {
          return getSmileCode(options.eventKey /* ticket key */)
            .then(function(ticketNumber) {
              return raiseTicket(ticketNumber, options);
            });
        }

        return {
          logEvent: logEvent
        };
      }]);
})(angular);

